import { StyleSheet, Text, View, Image } from 'react-native'
import React from 'react'

const WelcomeSix = () => {
  return (
    // <>
    //   <Text
    //     style={{
    //       fontWeight: 'bold',
    //       fontSize: 27,
    //       color: 'white',
    //       alignSelf: 'center'
    //     }}
    //   >
    //     Messages
    //   </Text>

    //   {/* <Text
    //     style={{
    //       fontSize: 17,
    //       color: 'white',
    //       alignSelf: 'center',
    //       marginTop: '5%'
    //     }}
    //   >
    //     Messages allow you to send notes to
    //   </Text>
    //   <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
    //     colleagues.
    //   </Text> */}

    //   <View style={[styles.rectangle]}>
    //     <Image
    //       source={require('../../../static/images/Welcome-Messages.png')}
    //       style={[styles.appBrand]}
    //       resizeMode="contain"
    //     />
    //   </View>
    // </>
    <>
      <Text
        style={{
          fontWeight: 'bold',
          fontSize: 27,
          color: 'white',
          alignSelf: 'center'
        }}
      > Messages</Text>
      <Image
        source={require('../../../static/images/Welcome-Messages.png')}
        style={[styles.appBrand]}
        resizeMode="contain"
      />
    </>
  )
}

export default WelcomeSix

const styles = StyleSheet.create({
  rectangle: {
    alignSelf: 'center',
    marginTop: '20%',
    width: '30%',
    height: '64%',
    //backgroundColor: 'white',
    borderRadius: 15
  },
  appBrand: {
    width: '50%',
    height: '70%',
    alignSelf: 'center'
    // marginTop:'10%'
  }
})
